module.exports = "/_next/static/images/fallback_logo-48be501045273a6c2bb1919e8aa7379f.png";